'use client';
import Link from 'next/link';

const extraServices = [
  {
    icon: 'fas fa-house-medical',
    title: 'Soins à Domicile',
    description: 'Nos médecins et infirmiers se déplacent directement chez vous pour des consultations, soins infirmiers, prises de sang et suivis post-opératoires. Confort et qualité garantis.',
    color: '#0e5932',
    link: '/services/soins-domicile',
    badge: 'Nouveau',
  },
  {
    icon: 'fas fa-building',
    title: 'Services aux Entreprises',
    description: 'Médecin référent, bilans annuels, suivi médical des employés, vaccinations et programmes de prévention. COSA est votre partenaire santé en entreprise.',
    color: '#fbaf45',
    link: '/services/entreprises',
    badge: 'Partenariat',
  },
  {
    icon: 'fas fa-clipboard-check',
    title: 'Check-Up Médical',
    description: 'Bilan de santé complet personnalisé : examens biologiques, imagerie, consultations spécialisées. Détectez tôt, agissez vite. Forfaits adaptés à chaque profil.',
    color: '#0e5932',
    link: '/services/check-up',
    badge: 'Prévention',
  },
];

export default function HomeCareServicesSection() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-14">
          <span className="text-xs font-bold uppercase tracking-widest mb-3 block" style={{ color: '#fbaf45' }}>
            Services Innovants
          </span>
          <h2 className="text-3xl md:text-4xl font-black mb-4" style={{ color: '#1d3c5e', fontFamily: 'Lato, sans-serif' }}>
            Des Soins Adaptés à Votre Mode de Vie
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base">
            COSA va au-delà du centre médical traditionnel. Nous apportons la santé là où vous en avez besoin.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {extraServices?.map((svc, i) => (
            <div
              key={i}
              className="relative rounded-2xl overflow-hidden shadow-lg group transition-all duration-300 hover:-translate-y-2 hover:shadow-2xl"
              style={{ border: `2px solid ${svc?.color}20` }}
            >
              {/* Top accent bar */}
              <div className="h-1.5 w-full" style={{ backgroundColor: svc?.color }}></div>

              <div className="p-8">
                {/* Badge */}
                <span
                  className="inline-block text-xs font-bold uppercase tracking-wider px-3 py-1 rounded-full mb-5"
                  style={{ backgroundColor: `${svc?.color}15`, color: svc?.color }}
                >
                  {svc?.badge}
                </span>

                {/* Icon */}
                <div
                  className="w-16 h-16 rounded-2xl flex items-center justify-center mb-6 text-2xl text-white"
                  style={{ backgroundColor: svc?.color }}
                >
                  <i className={svc?.icon}></i>
                </div>

                <h3 className="text-xl font-black mb-3" style={{ color: '#1d3c5e', fontFamily: 'Lato, sans-serif' }}>
                  {svc?.title}
                </h3>
                <p className="text-gray-500 text-sm leading-relaxed mb-6">
                  {svc?.description}
                </p>

                <Link
                  href="/rendez-vous"
                  className="inline-flex items-center gap-2 text-sm font-bold transition-colors"
                  style={{ color: svc?.color }}
                >
                  En savoir plus <i className="fas fa-arrow-right text-xs"></i>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
